module.exports = __webpack_public_path__ + "static/15-3c146aa7b946e001925a296c3821bd62.jpg";